export const QUERYABLE_PROJECT_STATUSES = [
  "active",
  "paused",
  "completed",
] as const

export type QueryableProjectStatus = (typeof QUERYABLE_PROJECT_STATUSES)[number]

export const ALL_PROJECT_STATUSES = [
  "active",
  "paused",
  "completed",
  "archived",
] as const

export type AllProjectStatus = (typeof ALL_PROJECT_STATUSES)[number]

export const PROJECT_DOCUMENTS_BUCKET = "project_docs"
